<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
// import { ModelListSelect } from "vue-search-select";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "User Roles",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
  },
  data() {
    return {
      title: "System User Roles",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "User Roles",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "role_field",
          sortable: true,
          label: "ROLE NAME",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingRole: [],
      nameError: "",
      branchError:"",

      // Value from user input for adding position
      data: {
        name: "",
        branch_id: "All"
      },
      // edit position
      editdata: {
        new_name: "",
        branch_id: "",
        id: "",
      },
      // delete position
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("users", ["ROLES", "USER_SAVING"]),
    ...mapGetters("auth", ["user_permissions" ,"branch_id"]),
    ...mapGetters("branch", ["GetBranch"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ROLES ? this.ROLES.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ROLES ? this.ROLES.length : 1;
  },
  watch: {//#endregion#
   notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchUserRoles: "users/fetchUserRoles",
      AddUserRole: "users/addUserRole",
      EditUserRole: "users/editUserRole",
      DeleteUserRole: "users/deleteUserRole",
      FetchAdminUsers: "users/fetchAdminUsers",
      FetchBranch: "branch/fetchBranch",
      AuthenticatedUser: "auth/Authenticated_user",
      
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },


    addRole(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Role name field is required";
        return;
      }else {
        this.nameError = "";
      }
      if (this.branch_id == 0 && this.data.branch_id === "") {
        this.branchError = "Branch field is required";
        return;
      }else {
        this.branchError = "";
      }
      this.AddUserRole(this.data);
    },

    resetAddRole() {
      this.data.name = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditRole() {
      this.editdata.new_name = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteRole() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },
    showEditModal(data) {
      this.editdata.new_name = data.item.roleName;
      this.editdata.id = data.item.id;
    },
    editRole(modalId) {
      this.modal_id = modalId;
      this.EditUserRole(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.roleName;
      this.deletedata.id = data.item.id;
    },
    deleteRole(modalId) {
      this.modal_id = modalId;
      this.DeleteUserRole(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchUserRoles();
    this.FetchAdminUsers();
    this.FetchBranch();
    this.AuthenticatedUser();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>                 
                  <b-button v-if="user_permissions.add_user_role" class="float-end" variant="primary" v-b-modal.add-role-modal
                    ><i class="fa fa-plus"></i> Add Role</b-button
                  >

                  <!-- modal starts -->
                  <b-modal id="add-role-modal" hide-footer @hidden="resetAddRole">
                    <template #modal-title> Add New User Role </template>
                    <div class="form-group mb-3" v-if="branch_id == 0">
                    <label>Select Branch</label>
                    <select                       
                        v-model="data.branch_id"
                        class="form-control"                      
                      >
                        <option value="All">All</option>
                        <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                      </select>
                    <div class="text-danger" v-if="branchError">
                      <em>{{ branchError }}</em>
                    </div>
                  </div>
                    <div class="form-group mb-3">
                      <label>Role Name</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Role Name"
                          class="form-control"
                          v-model="data.name" 
                          @input="resetError"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        data-dismiss="modal"
                        @click="closeModal('add-role-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addRole('add-role-modal')"
                      >
                        <i class="fa fa-check"></i>
                        Submit
                        <b-spinner
                          v-if="USER_SAVING"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ROLES ? ROLES : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(role_field)="data">
                  {{ data.item.roleName }} - {{ data.item.Branch?data.item.Branch.branchName:"Admin" }}
                </template>

                <template #cell(actions)="data">
                  <b-button v-if="user_permissions.edit_user_role"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-role-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-else
                  disabled
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-role-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    v-if="data.item.type != 0 && user_permissions.delete_user_role"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-role-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!ROLES" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-role-modal" hide-footer @hidden="resetEditRole">
              <template #modal-title> Edit Role {{ editdata.new_name }}</template>
              <div class="form-group mb-3" v-if="branch_id == 0">
                <label>Select Branch</label>
                <select                       
                    v-model="editdata.branch_id"
                    class="form-control"                      
                  >
                    <option value="All">All</option>
                    <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                  </select>
                <div class="text-danger" v-if="branchError">
                  <em>{{ branchError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Role Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.new_name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>             
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-role-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editRole('edit-role-modal')"
                >
                  <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="USER_SAVING"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete role starts -->
            <b-modal id="delete-role-modal" hide-footer @hidden="resetDeleteRole">
              <template #modal-title>
                <h4 class="text-danger">Delete Role {{ deletedata.name }}</h4></template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this role? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-role-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteRole('delete-role-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="USER_SAVING"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
